import React, { memo } from "react";

import { Row ,Col,Card,Button,Modal} from 'react-bootstrap';
import { NavLink } from "react-router-dom";

const TestFinished = memo( function TestFinished() {

	return (
		<div className="content questionsArea deviceTestPage mock-container">
			<Row>
				<Col xs={12}>
					<Card className="mock-header-gap shadow-none border-0">
						<Card.Body className="test-finished-message mock-resource-text text-center">
							<Row className='unselectable'>
								<div className="row">
									<div className="mt-0 col-12">
										<div className="mock-resource-text">This Full Mock Test is finished.</div>
									</div>
									<div className="row mt-3 justify-content-center g-3">

										<div className="col-12 col-sm-6 col-md-4 col-lg-3">
											<NavLink to="/admin/dashboard" className="text-decoration-none d-block">
											<Button className="w-100 text-center">
												Go to Dashboard
											</Button>
											</NavLink>
										</div>

										<div className="col-12 col-sm-6 col-md-4 col-lg-3">
											<NavLink to="/admin/mock-result" className="text-decoration-none d-block">
											<Button className="w-100 text-center">
												See Results
											</Button>
											</NavLink>
										</div>

									</div>

								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default TestFinished;